<template>
  <v-card class="mx-auto" max-width="344" width="100%" outlined>
    <div class="overline mb-4 mt-3 ml-3">
      {{ $t("components.data.dataAlerts.alerts") }}
    </div>
    <div v-if="selectedAlerts.length !== 0">
      <div v-for="alert in selectedAlerts" :key="alert.id">
        <v-card flat>
          <v-divider></v-divider>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">{{ alert.type }}</div>
              <v-list-item-title class="headline mb-1">{{
                alert.device_sensor.sensor.display_name
              }}</v-list-item-title>
              <v-list-item-subtitle class="mb-4">
                {{ alert.message }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mb-4">
                {{ getDate(alert.created) }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar tile size="80" color="white">
              <v-icon x-large> mdi-alert </v-icon></v-list-item-avatar
            >
          </v-list-item>
        </v-card>
      </div>
    </div>
    <div v-else>
      <v-card flat>
        <v-list-item three-line>
          <v-list-item-content>
            <v-card-text class="mb-1 subtitle-1 mt-0 pt-0">
              {{
                $t("components.data.dataAlerts.noAlertsFoundForThisDateRange")
              }}
            </v-card-text>
          </v-list-item-content>

          <v-list-item-avatar tile size="80" color="white" class="mt-0 pt-0">
            <v-icon x-large> mdi-check-circle </v-icon></v-list-item-avatar
          >
        </v-list-item>
      </v-card>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ["selectedAlerts"],
  components: {},
  data: () => ({}),
  methods: {
    getDate(item) {
      return this.$moment(item * 1000).format("Do MMM, h:mm");
    },
  },
};
</script>
